<template>
  <section class="container-4xl-w mx-auto">
        <!-- header  -->
       <Header  v-if="!isPhoneSize()"/>

        <!-- section for header in phone size   -->
        <header  v-if="isPhoneSize()" class="w-full h-full py-4 rtl relative mb-8">

            <section class="bg-white shadow shadow-sm h-14 fixed top-0 inset-x-0 z-50 px-4 flex items-center justify-between">  
                 <!-- div for sitename and arow icon  -->
                <div>
                    <button @click="goBack"  class="public-text-b text-red-500 hover:text-amber-500 flex items-center">
                           <!-- icon  -->
                           <FontAwesomeIcon icon="arrow-right" class="bold ml-1" style="width: 1.2rem" />
                           <!-- site name  -->
                           <span>بازگشت</span>
                    </button>
                </div>
                   <!-- div for shopping cart Icons and favorites  -->
                   <div class="flex items-center">

                        <!-- favorites  and heart icons-->
                        <div  @click="favoraite = !favoraite"  class="mx-4 cursor-pointer relative group">
                          <!-- favorites -->

                          <!-- <FontAwesomeIcon icon="heart" class="text-gray-300 h-6 w-6" v-if="favoraite" /> -->

                          <!-- heart -->

                          <!-- <FontAwesomeIcon icon="heart" class="text-red-500 h-6 w-6" v-else /> -->

                          <!-- div for show text when user hover on favorite  -->

                          <!-- <div class="absolute top-6 -left-4 min-w-32 bg-gray-700 h-6 public-text1-b text-white hidden group-hover:flex-center rounded">
                             <span v-if="favoraite"> افزودن به علاقه مندی ها</span>
                             <span v-else> حذف از علاقه مندی ها</span>
                          </div> -->
                        </div>

                        <!-- shopping cart  -->
                        <span ref="basket_menu" class="relative z-10 group cursor-pointer" @click="goCart">
                            <!-- icons  -->
                            <FontAwesomeIcon icon="cart-plus" class="w-6 h-6 text-gray-500 group-hover:text-blue-500 transition-colors duration-75 "/>
 
                             <!-- number qty cart item  -->
                             <span class="absolute inline-flex items-center justify-center w-[1.125rem] h-[1.125rem] text-xs font-sm text-white bg-red-700 border border-white rounded-full -top-2 -right-1 ">
                                 <span v-if="qtyCart">{{ (qtyCart) }}</span>
                                 <span v-else>0</span>
                             </span >
                             <transition name="fade">
                               <div v-if="basketAlert" class="absolute top-7 left-0 px-4 py-2  bg-gray-700 rounded-lg text-white public-text2 min-w-28 after:content-['']">
                                 <p class=" w-full h-full relative after:content-[''] after:absolute after:-left-2 after:-top-3 after:w-3 after:h-3 after:bg-gray-700 after:rotate-45" >
 
                                 </p>
                                   رفتن به سبد خرید
                               </div>                         
                             </transition>
                        </span>

                   </div>

            </section>

        </header>

         <!-- breadCrump  for pc -->
        <section class="container-4xl-w mx-auto px-4  " :class="isPhoneSize() ? '' : 'mt-[9rem]'" >
            <div class="h-6  w-full"> 
  
                <breadCrump class="" v-if="productCategory" :chechCategory="chechCategory1" :productName="product.name" :category="productCategory"/>
                <div v-else class="shimmer-text w-72 h-6 "></div>
            </div>              
        </section> 

       <!-- section for image and details  -->
       <section class="ontainer-4xl-w mx-auto px-2 grid grid-cols-12 gap-4">
         <!-- section for image  -->
           <section class="col-span-12 lg:col-span-4  min-h-72">

            <!-- image section for phone  -->
               <section class="w-full h-full" v-if="isPhoneSize()"> 
                <div class="w-full h-full flex-center">
                      <div v-if="!pictures.length" class="min-h-60 w-full  flex-center">
                      <div class="h-20 w-20 rounded-full border-t-2 border-blue-200  animate-spin"></div>
          
                    </div>
                       <swiperImage v-else :pictures="pictures" />
                  </div>
               </section>

               <!-- image section for pc  -->
                <section v-else class="text-center" >
                  <!-- magnify  -->
                  <div class="w-full p-2 min-h-[30rem]  flex-center " > 
                    <div v-if="!pictures.length" class="min-h-[30rem] w-full  flex-center">
                      <div class="h-20 w-20 rounded-full border-t-2 border-blue-200  animate-spin"></div>
          
                    </div>
                      <magnifyComponent v-else  :key="change_img" :srcImage="getPictureUrl(tab)" />
                  </div>
                    
                  <!-- swiper image  -->
                   <div class="w-full mb-2 ">
                      <swiperProductImage  :images="pictures" @tabItem="changeTab" :name="productName"/>
                  </div>

                </section>

           </section>

           <!-- section for details  -->
           <section id="details" class="col-span-12 lg:col-span-8  ">
               <!-- product name    -->
               <h1 v-if="productName" class="public-text-title color-gray-500 min-h-8">
                    {{ productName }}
                </h1>
                <!-- skeleton  -->
                <h1 v-else class="shimmer-text min-h-8 w-48">
                </h1>
                <!-- product price  -->
                <div class="flex items-center public-text1-b h-8 my-2 ">
                    <del class="text-red-500" v-if="priceProduct && discounted_price">{{ digitsEnToFa(formatNumber(priceProduct)) }}</del>
                    <span v-else-if="priceProduct && !discounted_price" class="text-green-500">{{ digitsEnToFa(formatNumber(priceProduct)) }}</span>
                    <!-- skeleton  -->
                    <del v-else class="shimmer-text w-12 mr-1"></del>
                    <span class="inline-block mx-1" :class="discounted_price?'text-red-500':'text-green-500'" >تومان</span>
                </div>

                <!-- <product discount price  -->
                <div class="h-8 w-12">
                  <div v-if="discounted_price" class="flex items-center">
                    <div  class="flex items-center public-text1-b text-green-500">
                         <span >{{ digitsEnToFa(formatNumber(discounted_price)) }}</span>
                         <span class="inline-block mx-1">تومان</span>
                    </div>
                 
                  </div>
                 </div>


                
                 <!-- details component  -->
                 <div  class="min-h-48 lg:min-h-60  w-full">
                      <clotheDetails :products="product" :pictures="getPictureUrl(tab)" />       
                 </div> 

                 <!-- route params name  -->
                 <div class="public-text1-b flex items-center pt-4 border-t border-blue-200 gap-1">
                      <span>شناسه محصول :</span>
                      <span v-if="route.params.name"  class="text-gray-500 ">{{ route.params.name }}</span>
                      <!-- skeleton  -->
                      <span v-else class="shimmer-text max-w-40 inline-block"></span>
                </div>       
                 
                <!-- categoryies  -->
                <div class="public-text1-b my-2 my-4  flex items-center gap-1" >
                    <span>دسته :</span>
                    <span v-if="category" class="text-gray-500" >{{ category }}</span>
                    <!-- skeleton  -->
                    <span v-else class="inline-block max-w-16 shimmer-text mt-1"></span>
                 </div>
                
                 <!-- labels  -->
                <div class="public-text1-b  flex itemx-center gap-1">
                     <span>برچسب ها :</span>
                     <span v-if="tags">
                         <button @click="tag(item)" class="text-gray-500  hover:text-blue-400" v-for="(item, index) in tags" :key="index" >
                             {{ item }}
                             <span class="inline-block" v-if="index !== tags.length - 1" :aria-label="`برچسب: ${item}`" >
                              ،
                             </span>
                         </button>
                     </span>
                     <!-- skeleton  -->
                     <span v-else class="inline-block mt-[0.125rem] max-w-40 shimmer-text"></span>
                </div>
            </section>

       </section>

       <!-- section for description  -->
       <section class="container-4xl-w mx-auto w-full   px-2 my-4" :class="specifications.length?'min-h-72':''">
        <div v-if="specifications" class="border-t-2 border-blue-200 w-full my-4"></div>
          <descriptionComponent v-if="specifications"  :description="description" :specifications="specifications" />
       </section>

       <!-- section for comments  -->
       <section class="container-4xl-w mx-auto w-full px-4 ">
        <div  class="border-t-2 border-blue-200 w-full my-4"></div>
          <comentsComponent :productId="productId" :productName="productName" />   
       </section>

       <div class="container-4xl-w mx-auto w-full  px-4">
        <div class="w-full h-[2px] bg-blue-200 my-2"></div>
       </div>

       <!-- section for similar product  -->
        <section class="container-4xl-w mx-auto w-full px-4 mb-[5.4rem] lg:mb-2">
          <similarProduct :similar-products="similarProducts"/>
        </section>

      <Footer v-if="!isPhoneSize()" />

  </section>
</template>
<script setup>
import {ref,computed,onBeforeMount,defineAsyncComponent, watch, onMounted,onUpdated} from 'vue'

import { isPhoneSize } from '@/utils/isPhoneSize';

import breadCrump from '@/components/product/breadCrump.vue'

import Footer from '@/components/Footer/footerSection.vue'

import clotheDetails from '@/components/product/detailsComponent/clotheDetails.vue';

import Header from '@/components/Header/headerSection.vue'
 
import swiperProductImage from '@/components/product/swiperProductImage.vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import swiperImage from '@/components/product/swiperImage.vue';

import { useRoute, useRouter  } from 'vue-router';

import { useHead } from "@vueuse/head";

import magnifyComponent from '@/components/product/magnifyComponent.vue';

const descriptionComponent = defineAsyncComponent(() =>import("@/components/product/descriptionComponent.vue"));

const comentsComponent = defineAsyncComponent(() =>import('@/components/product/comentsComponent.vue'));

const similarProduct = defineAsyncComponent(() =>import('@/components/product/similarProduct.vue'));

import { digitsEnToFa } from "persian-tools";

// pinia 
import { useCartStore } from '@/store/cart';

import axios from 'axios';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-CSRFToken"] = cookies.get("csrftoken");
const formatNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،");
};

const favoraite=ref(false);

const route = useRoute();
const router=useRouter();

// tab is for change image url
const tab = ref("");

// pictures use save product images 
const pictures = ref([]);

// productName save product name 
const productName = ref();

// priceProduct save product price 
const priceProduct = ref(0);

// discounted_price seve product discounte price 
const discounted_price = ref(0);

// productCategory use in breadCrump props 
const productCategory = ref();

// pinia variable 
const cartItems=useCartStore();

// set cart items if cart items exsist or set new cart id 
cartItems.arrayQuantity();

// qtyCart for show sun cart item 
const qtyCart = computed(() => cartItems.getQtyCartItem);

// product save product details 
const product=ref();

// productId save product id 
const productId = ref(); 

// categoryId save category id 
const categoryId = ref();

// category save category name 
const category = ref();

//  chechCategory use in breadcrumb prop
const chechCategory1 = ref(false)

// tags use for save product labels 
const tags = ref();

// change_img use for magnify refresh wen user click on omage to see 
const change_img=ref(1)

//specifications and description for define product 
const description=ref()
const specifications=ref([])

// similarProducts use for save similar product 
const similarProducts=ref()

// basketAlert use for show cart alert 
const basketAlert=ref(false)

// goCart function is for redirect cart page 
const goCart=()=>{
      if(qtyCart.value)
      router.push('/cart')
    }

// getPictureUrl return image url 
const getPictureUrl = (picture) => {
  return "https://parsinekala.com" + picture;
};

// setProduct is for set data from api 
 const setProduct = async () => {
   // send request for recieve product
    try {
      const response1=await axios.post(`https://parsinekala.com/backend/api/products/slug/${route.params.name}/`)
       product.value = response1.data;
      priceProduct.value = response1.data.variations[0].price;
      discounted_price.value = response1.data.variations[0].discounted_price;
      productName.value = response1.data.name;
      productId.value = product.value.id;
      categoryId.value = product.value.category.id;
      tab.value = response1.data.images[0].image;
      pictures.value.length = 0;
      product.value.images.forEach((element) => {pictures.value.push(element.image);});
      description.value=product.value.description;
      product.value.specifications;
      specifications.value=product.value.specifications;
      //  set categories 
      if (product.value) {
          productCategory.value = product.value.category;
        }

        chechCategory1.value = true;
       if (product.value.tags) {
         tags.value = product.value.tags.split("،");
       }
       category.value = product.value.category.name;

       try {
      
        const response=await axios.post(`https://parsinekala.com/backend/api/products/?category=${categoryId.value}`)
        similarProducts.value=response.data;
       } catch (error) {
        console.log(error)
       }

     } catch (error) {
        console.log(error)

  }
 }

//  back to flast page 
const goBack = () => {
  if (window.history.length > 1) {
    window.history.back(); // Go back if there is history
  } else {
    window.close(); // Close the tab if there's no history
  }
};

// changeTab recive data from emit
const changeTab = (x) => {
  tab.value = x;
  change_img.value=Math.random()
};

//  tag use for send to tag route 
const tag = (tag) => {
    let item = tag.replace(/ /g, "-");
    router.push({ name: "tag", params: { name: item } });
    };


 const setMetaTags = () => {
// Use useHead to set the new meta tags
useHead({
    link: {
      rel: "canonical",
      href: encodeURI(`https://parsinekala.com/product/${route.params.name}`),
    },
  });
};

onBeforeMount(() => {
     setProduct();
});

watch(qtyCart,
  () => {
    if (qtyCart.value) {
      setTimeout(() => {
        basketAlert.value = true;
        setTimeout(() => {
          basketAlert.value = false;
        },3000)      
      },3000)
    }
  })

  // watch(() => route.params.name, () => {
  //   setProduct();
  // });

  onMounted(() => {
    setMetaTags();
  });

  onUpdated(() => {
  setMetaTags();
});


</script>

